import api from './axios';

export const fetchCampaigns = () => api.get('/campaigns').then((r) => r.data);

export const createCampaign = (body) => api.post('/campaigns', body).then((r) => r.data);

export const updateCampaign = (id, body) => api.put(`/campaigns/${id}`, body).then((r) => r.data);

export const publishCampaign = (id) => api.post(`/campaigns/${id}/publish`).then((r) => r.data);

export const unpublishCampaign = (id) => api.post(`/campaigns/${id}/unpublish`).then((r) => r.data);

